import type { RootState } from 'app/store';
import { ActiveTabType } from 'data/types';
import { UIState } from 'features/ui/ui-slice';
import { findAdminTabContext } from 'utils/admin-tabs';

const STEP_SELECTORS: Partial<
  Record<ActiveTabType, (ui: UIState) => string | null>
> = {
  project: (ui) => ui.activeProjectStepId,
  structure: (ui) => ui.activeStructureStepId,
  configurations: (ui) => ui.activeConfigurationStepId
};

export function getCurrentPage(
  state: RootState,
  pathname: string = window.location.pathname
): string {
  if (pathname.startsWith('/admin')) {
    const tabName = findAdminTabContext(state.ui.activeAdminTab)?.tabName;
    return tabName ? `admin/${tabName}` : 'admin';
  }
  if (pathname !== '/') {
    return pathname.replace(/^\/+/, '');
  }
  const { activeTab } = state.ui;
  const step = STEP_SELECTORS[activeTab]?.(state.ui);
  return step ? `${activeTab}/${step}` : activeTab;
}
